"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosStockMovementCreateInputSchema = exports.APosStockMovementSchema = exports.APosMovementReferenceTypeSchema = exports.APosMovementTypeSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
const stock_event_schema_1 = require("./stock-event.schema");
exports.APosMovementTypeSchema = zod_1.z.enum([
    'sale', 'return', 'adjustment', 'transfer_in', 'transfer_out',
    'grn_receipt', 'damage', 'dispose', 'po_receipt', 'count_adjustment',
    'return_received', 'return_restocked', 'return_damaged',
    'reservation', 'reservation_release', 'marketplace_order',
    'transfer_damage', 'stock_reset',
]);
exports.APosMovementReferenceTypeSchema = zod_1.z.enum([
    'order', 'return', 'exchange', 'grn', 'transfer', 'purchase_order',
    'stock_count', 'manual', 'damage_report',
    'count', 'adjustment', 'damage', 'marketplace_order', 'stock_reset',
]);
exports.APosStockMovementSchema = zod_1.z.object({
    pk: zod_1.z.string().optional(),
    sk: zod_1.z.string().optional(),
    tenantId: id_schema_1.TenantIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    movementId: id_schema_1.EntityIdSchema,
    timestamp: zod_1.z.number(),
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    type: exports.APosMovementTypeSchema,
    operation: stock_event_schema_1.APosStockOperationSchema.optional(),
    bucket: stock_event_schema_1.APosQuantityBucketSchema.optional(),
    quantity: zod_1.z.number(),
    previousQuantity: zod_1.z.number(),
    newQuantity: zod_1.z.number(),
    previousBalance: zod_1.z.number().optional(),
    newBalance: zod_1.z.number().optional(),
    unitCost: zod_1.z.number().nonnegative().optional(),
    totalCost: zod_1.z.number().optional(),
    referenceType: exports.APosMovementReferenceTypeSchema,
    referenceId: id_schema_1.EntityIdSchema,
    secondaryReferenceType: exports.APosMovementReferenceTypeSchema.optional(),
    secondaryReferenceId: id_schema_1.EntityIdSchema.optional(),
    batchId: zod_1.z.string().optional(),
    serialNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    userId: id_schema_1.EntityIdSchema,
    userName: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(500).optional(),
    sourceService: zod_1.z.string().optional(),
    anomalyFlag: stock_event_schema_1.APosAnomalyTypeSchema.optional(),
    anomalyScore: zod_1.z.number().min(0).max(1).optional(),
    createdAt: zod_1.z.number(),
});
exports.APosStockMovementCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    type: exports.APosMovementTypeSchema,
    quantity: zod_1.z.number(),
    unitCost: zod_1.z.number().nonnegative().optional(),
    referenceType: exports.APosMovementReferenceTypeSchema,
    referenceId: id_schema_1.EntityIdSchema,
    batchId: zod_1.z.string().optional(),
    serialNumbers: zod_1.z.array(zod_1.z.string()).optional(),
    notes: zod_1.z.string().max(500).optional(),
});
//# sourceMappingURL=stock-movement.schema.js.map